export async function retryUntilSuccess(fn, options = {
    interval: 5000,
}) {
    try {
        return await fn();
    }
    catch (e) {
        if (options.signal?.aborted) {
            throw new Error('Aborted');
        }
        if (options.retries !== undefined && options?.retries === 0) {
            throw e;
        }
        await new Promise(resolve => setTimeout(resolve, options.interval ?? 5000));
        if (options.retries !== undefined) {
            options.retries--;
        }
        return retryUntilSuccess(fn, options);
    }
}
